import styled, { css } from 'styled-components';

export const AddressList = styled.div`
    margin-bottom: 30px;

    ${({ noMarginBottom }) => noMarginBottom && css`
        margin-bottom: 0;
    `}
`;
